// A device's first visit, kept raw and tiny: this runs on every page, the vote page included
// (50 KB budget), so it imports nothing. The referrer's host and the path are normalized only
// when the first poll is made (source.ts). Never under Global Privacy Control or Do Not Track,
// and never on a device that already has polls.
export const FIRST_VISIT_KEY = "flp_first_source";

export function captureFirstVisit(env: { referrer?: string; pathname?: string; nav?: Navigator } = {}): void {
  try {
    const nav = (env.nav ?? navigator) as Navigator & { globalPrivacyControl?: boolean };
    if (nav.globalPrivacyControl || nav.doNotTrack === "1") return;
    const polls = localStorage.getItem("flp_my_polls");
    if (localStorage.getItem(FIRST_VISIT_KEY) || (polls && polls !== "[]")) return;
    const referrer = env.referrer ?? document.referrer;
    localStorage.setItem(FIRST_VISIT_KEY, JSON.stringify({ ref: referrer ? new URL(referrer).host : "", land: env.pathname ?? location.pathname }));
  } catch {
    // Measurement never breaks the product.
  }
}
